import React, { FunctionComponent } from 'react';

import classnames from 'classnames';
import { Table as BootstrapTable, TableProps as BootstrapTableProps } from 'react-bootstrap';

import { Variant } from 'core/util/Bootstrap';

import 'core/table/basic/Table.scss';

export interface TableProps extends BootstrapTableProps {
    borderedCells?: boolean;
    children?: any;
}

export const isBordered = (props: Partial<TableProps>): boolean => !!(props.bordered || props.borderedCells);

export const generateTableClassNames = (props: Partial<TableProps>): string =>
    classnames('r4e-table', props.className, {
        'r4e-table-unbordered': !props.bordered,
        'r4e-table-bordered-cells': props.borderedCells,
        'r4e-table-unbordered-cells': !props.borderedCells,
    });

export const Table: FunctionComponent<TableProps> = ({ children, ...others }) => {
    const tableClassNames = generateTableClassNames(others);
    const propsForBsTable = {
        ...others,
    };

    delete propsForBsTable.borderedCells;

    return (
        <BootstrapTable {...propsForBsTable} className={tableClassNames} bordered={isBordered(others)}>
            {children}
        </BootstrapTable>
    );
};

Table.defaultProps = {
    bordered: true,
    borderedCells: false,
    borderless: false,
    className: '',
    hover: true,
    responsive: false,
    striped: false,
    variant: Variant.Default,
};
